/** 票据流转 */
import {get, post, postByJson, F_URL} from './https.js';
import {C_URL} from "./https";

export default {

    // pagingTask: 分页查询分组任务
    pagingTask(param) { return get(F_URL + 'f0001/paging/task', param); },
    // getTaskById: 根据任务ID查询任务信息
    getTaskById(param) { return get(F_URL + 'f0001/get/task/by/id', param); },
    // 根据授课ID任务ID查询发送任务的信息
    getSendTaskByGlIdAndGtId(param) { return get(F_URL + 'f0001/get/send/task', param); },
    // deleteTaskById：根据ID删除任务
    deleteTaskById(param) { return post(F_URL + 'f0001/delete/task/by/id', param); },
    // listTable：获取分组任务的表格信息
    listTable(param) { return get(F_URL + 'f0001/list/table', param); },
    // listRole：获取分组任务的角色信息
    listRole(param) { return get(F_URL + 'f0001/list/role', param); },
    // 共享分组任务
    shareTask(param) { return postByJson(F_URL + "f0001/share", param); },
    // 查询共享部门和用户列表
    listDeptAndShareUser(param) { return get(F_URL + "f0001/list/share/user", param); },
    // 查询共享部门和用户列表
    listSchoolAndDeptAndShareUser(param) { return get(F_URL + "f0001/list/share/userBySchool", param); },

    // 差旅费
    // getClfTopic：获取差旅费的题干信息
    getClfTopic(param) { return get(F_URL + 'f0001/clf/topic', param); },
    // listClfTravel：获取差旅费的行程
    listClfTravel(param) { return get(F_URL + 'f0001/clf/list/travel', param); },
    // listClfOtherCost：获取差旅费的其他费用信息
    listClfOtherCost(param) { return get(F_URL + 'f0001/clf/list/other/cost', param); },
    // saveClf：获取差旅费的其他费用信息
    saveClf(param) { return postByJson(F_URL + 'f0001/clf/save', param); },
    // 保存材料采购 分组任务
    saveClcg(param) { return postByJson(F_URL + 'f0001/clcg/save', param); },
    // 获取材料任务信息
    getBuyInfo(param) { return get(F_URL + 'f0001/clcg/buy/info', param); },
    // 获取货物信息
    getGoods() { return get(F_URL + 'f0001/clcg/list/goods'); },
    // 获取材料采购任务公司信息
    getCompany() { return get(F_URL + 'f0001/clcg/list/company'); },

    // --------------------------------------

    // 查询分组任务分页列表
    pagingGroupTask(param) { return get(F_URL + 'f0001/paging/gt/td', param); },

    // 获取分组任务模板列表
    getListGtTemplate() { return get(F_URL + 'f0002/list/template'); },
    // 获取分组任务模板列表
    getListRole(param) { return get(F_URL + 'f0002/list/role',param); },
    // 获取交通工具列表
    getListTransport() { return get(F_URL + 'f0002/list/transport'); },
    // 获取任务的表格，元素及答案
    getTastTables(params) { return get(F_URL + 'f0002/list/table', params); },

    // 创建差旅费分组任务
    createClfGroupTask(param) { return postByJson(F_URL + 'f0002/save/gt/clf',param);},
    // 获取差旅费题干
    getCLFGroupTask(param) { return get(F_URL + 'f0001/clf/get/group/task',param);},
    // 获取分组任务详细信息
    getMGroupTaskInfo(param) { return get(F_URL + 'f0002/info/clf', param); },
    // 更新分组任务
    updateMGroupTaskInfo(param) { return postByJson(F_URL + 'f0002/update', param); },
    // 分组任务进度说明
    getGroupTaskStatus(param) { return get(F_URL + 'f0001/list/node', param); },
    // 获取分组任务状态列表
    getExecStatus(param) { return get(F_URL + 'f0001/get/task/process', param); },
    // 票据流转 一组学生作答结果
    getStuTable(param) { return get(F_URL + 'f0001/list/task/send/team/table/answer', param); },
    // 票据流转
    getStuScore(param) { return get(F_URL + 'f0001/list/task/role/score', param); },


}



// WEBPACK FOOTER //
// ./src/components/tools/request/https-f.js